// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
const Loading = (props: ReactProps) => (
    <div className="preloader-container">
        <div className="preloader-content pagination-centered">{InovxLoader.t("common:message.loading")}</div>

    <div className="preloader-content preloader-img-container">
        <div className="small1">
            <div className="small ball smallball1"></div>
            <div className="small ball smallball2"></div>
            <div className="small ball smallball3"></div>
            <div className="small ball smallball4"></div>
        </div>

        <div className="small2">
            <div className="small ball smallball5"></div>
            <div className="small ball smallball6"></div>
            <div className="small ball smallball7"></div>
            <div className="small ball smallball8"></div>
        </div>

        <div className="target">
            <div className="big ball"></div>
        </div>
    </div>
</div>
);

export default Loading;